const AlertIcon = ({ strokeColor = '#808080' }) => (
  <svg
    viewBox="0 0 795.1 795.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <style>{`
        .cls-1 { fill: #fcfcfc; }
        .cls-2 { fill: #4d4d4d; }
        .cls-3 {
          stroke: ${strokeColor};
          stroke-width: 50px;
          fill: none;
          stroke-miterlimit: 10;
        }
        .cls-4 {
          stroke: #fff;
          stroke-width: 20px;
          fill: none;
          stroke-miterlimit: 10;
        }
      `}</style>
    </defs>

    <g>
      <circle className="cls-2" cx="397.55" cy="397.55" r="388.66" />
      <circle className="cls-3" cx="397.55" cy="397.55" r="372.55" />
      <circle className="cls-4" cx="397.55" cy="397.55" r="343.4" />
    </g>

    <g>
      <path className="cls-1" d="M231.4,203.02c12.57-6.63,25.31-8.73,38.86-8.69,87.18.24,174.37-.8,261.52.53,41.5.63,62.8,21.26,63.35,62.56.78,58.41-.22,116.84.32,175.26.3,32.55-11.81,59.73-32.39,83.89-24.92,29.26-56.17,51.23-86.38,74.33-17.95,13.72-36.61,26.51-54.96,39.71-1.71,1.23-3.53,2.3-5.27,3.47-14.49,9.79-28.36,8.99-42.19-1.71-33.65-26.05-67.88-51.36-101.05-77.99-15.46-12.41-29.82-26.45-43.28-41.05-21.09-22.88-30.34-50.75-30.28-81.81.1-54.79-.12-109.58.27-164.36.15-20.78,2.95-41.11,19.89-56.08,3.33-2.94,7.34-5.11,11.59-8.05ZM445.64,226.05c-14.84-.03-29.67-.12-44.5-.06-47.22.17-94.45.05-141.66.76-16.71.25-25.54,9.6-27.68,26.41-.53,4.19-.79,8.45-.81,12.67-.26,53.89-.35,107.77-.69,161.66-.19,31.06,10.3,57.82,34.3,77.5,42.23,34.63,85.36,68.17,128.36,101.85,1.89,1.48,6.89,1.01,9.23-.47,10.94-6.92,21.99-13.85,32.01-21.99,33.51-27.23,67.17-54.32,99.63-82.77,21.67-19,31.18-43.96,30.76-73.4-.8-56-.2-112.02-.22-168.03,0-23.55-9.72-33.51-33.42-33.76-27.85-.3-55.7-.26-85.31-.37Z" />
      
      <path className="cls-1" d="M382.23,532.88c-13.18-22.3-25.96-44.05-38.77-65.79-4.08-6.93-7.51-14.01-2.77-21.95,4.6-7.7,11.97-9.16,20.34-9.08,23.61.23,47.22.03,70.83.1,17.15.05,25.93,13.62,17.76,28.59-14.37,26.36-29.38,52.38-44.33,78.41-4.84,8.43-12,8.12-17.28-.35-1.91-3.06-3.61-6.25-5.78-9.93ZM401.14,488.25c3.84-6.94,7.68-13.88,11.71-21.17h-33.09c5.77,10.22,11.03,19.52,16.61,29.39,1.6-2.55,2.97-4.75,4.77-8.22Z" />
    </g>
  </svg>
);

export default AlertIcon;